// extracted by mini-css-extract-plugin
export var container = "how-to-donate-section-module--container--1x5d0";
export var buttonGroup = "how-to-donate-section-module--button-group--wU3sB";
export var button = "how-to-donate-section-module--button--1QF4X";
export var buttonText = "how-to-donate-section-module--button-text--1AF7D";
export var buttonImage = "how-to-donate-section-module--button-image--1YX4e";
export var covid = "how-to-donate-section-module--covid--3qJO9";
export var ieLinks = "how-to-donate-section-module--ie-links--1TQEp";